import { Mapping } from 'api/MappingsAPI';
import { EVENT_FIELDS_EMPTY_STATE_CONFIG } from 'modules/dataDictionary/constants';
import { createColumns, createGridLayout } from 'modules/dataDictionary/utils';
import { FieldType } from 'modules/domains';
import noop from 'utils/noop';
import { Table, TableBody, TableHeader, TableRow } from '../Table';

export type CustomEventTableProps = {
  handleCreateNewField: (fieldName?: string) => void;
  hasError: boolean;
  isLoading: boolean;
  mappings: Mapping[];
  totalCount: number;
};

export const CustomEventTable = ({
  handleCreateNewField,
  hasError,
  isLoading,
  mappings,
  totalCount,
}: CustomEventTableProps) => {
  // get list of names of object fields
  const mappingObjectNames = mappings
    .filter((mapping) => mapping.fieldType === FieldType.OBJECT)
    .map((mapping) => mapping.fieldName);

  const isBulkActionEnabled = false;

  const gridLayout = createGridLayout(isBulkActionEnabled);
  const columns = createColumns(isBulkActionEnabled);

  return (
    <Table>
      <TableHeader fieldIds={[]} gridLayout={gridLayout} columns={columns} />
      <TableBody
        currentCount={mappings.length}
        emptyStateConfig={EVENT_FIELDS_EMPTY_STATE_CONFIG}
        hasError={hasError}
        isLoading={isLoading}
        totalCount={totalCount}
      >
        {mappings.map((event: Mapping) => {
          return (
            <TableRow
              key={event.fieldName}
              field={event}
              isBulkActionEnabled={isBulkActionEnabled}
              gridLayout={gridLayout}
              objectFieldNames={mappingObjectNames}
              onCreateNewField={() => handleCreateNewField(event.fieldName)}
              onSelectRow={noop}
            />
          );
        })}
      </TableBody>
    </Table>
  );
};
